var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragonflyLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "672px",
    height: "756px",
    viewBox: "0 0 672 756",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u77E9\u5F62") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M155.158824,234 L327.841176,234 C329.585746,234 331,235.096446 331,236.44898 L331,351.55102 C331,352.903554 329.585746,354 327.841176,354 L155.158824,354 C153.414254,354 152,352.903554 152,351.55102 L152,236.44898 C152,235.096446 153.414254,234 155.158824,234 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 179,
    height: 120,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M362.063158,156 L546.936842,156 C549.180862,156 551,157.337879 551,158.988235 L551,280.011765 C551,281.662121 549.180862,283 546.936842,283 L362.063158,283 C359.819138,283 358,281.662121 358,280.011765 L358,158.988235 C358,157.337879 359.819138,156 362.063158,156 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 193,
    height: 127,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M176.582353,390 L372.417647,390 C374.396126,390 376,391.096445 376,392.448979 L376,507.551021 C376,508.903555 374.396126,510 372.417647,510 L176.582353,510 C174.603874,510 173,508.903555 173,507.551021 L173,392.448979 C173,391.096445 174.603874,390 176.582353,390 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 203,
    height: 120,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62",
    transform: "translate(-4, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F6F7F9",
    fillRule: "nonzero",
    x: 4,
    y: 0,
    width: 672,
    height: 756
  }), /*#__PURE__*/React.createElement("g", {
    id: "Delivers-efficient,",
    transform: "translate(33, -50)",
    fill: "#353434",
    fillRule: "nonzero",
    fontFamily: "Helvetica",
    fontSize: 14,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Delivers-efficient,-stable,-and-secure-data-distribution-and-acceleration-powered-by-P2P"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 679
  }, "Delivers efficient, stable, and secure data distribution and acceleration powered by P2P")), /*#__PURE__*/React.createElement("text", {
    id: "technology,-with-an-optional-content\\u2011addressable-filesystem-that-accelerates-OCI-container"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 696
  }, "technology, with an optional content\u2011addressable filesystem that accelerates OCI container")), /*#__PURE__*/React.createElement("text", {
    id: "launch.-It-aims-to-provide-a-best\\u2011practice,-standards\\u2011based-solution-for-cloud\\u2011native"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 713
  }, "launch. It aims to provide a best\u2011practice, standards\u2011based solution for cloud\u2011native")), /*#__PURE__*/React.createElement("text", {
    id: "architectures,-improving-large\\u2011scale-delivery-of-files,-container-images,-OCI-artifacts,-AI/ML"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 730
  }, "architectures, improving large\u2011scale delivery of files, container images, OCI artifacts, AI/ML")), /*#__PURE__*/React.createElement("text", {
    id: "models,-caches,-logs,-dependencies,-etc."
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 747
  }, "models, caches, logs, dependencies, etc."))), /*#__PURE__*/React.createElement("g", {
    id: "Welcome-To-Dragonfly-Console-!",
    transform: "translate(33, -27)",
    fill: "#353434",
    fillRule: "nonzero",
    fontFamily: "Helvetica",
    fontSize: 19,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("text", null, /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 624
  }, "Welcome To Dragonfly Console !"))), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 180,
    y: 111,
    width: 182,
    height: 97,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.168421,226 L335.831579,226 C338.133734,226 340,227.453757 340,229.247058 L340,360.752942 C340,362.546243 338.133734,364 335.831579,364 L146.168421,364 C143.866266,364 142,362.546243 142,360.752942 L142,229.247058 C142,227.453757 143.866266,226 146.168421,226 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FBFBFB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.736842,381 L382.263158,381 C384.879243,381 387,382.443223 387,384.22353 L387,514.77647 C387,516.556777 384.879243,518 382.263158,518 L166.736842,518 C164.120757,518 162,516.556777 162,514.77647 L162,384.22353 C162,382.443223 164.120757,381 166.736842,381 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FBFBFB",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("use", {
    id: "path-1",
    stroke: "#979797",
    mask: "url(#mask-2)",
    strokeWidth: 2,
    fill: "#FBFBFB",
    fillRule: "nonzero",
    strokeDasharray: 10,
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 363,
    y: 302,
    width: 179,
    height: 99,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u4F18\\u6295\\u6295\\u8D44\\u5B75\\u5316",
    transform: "translate(162, 247)",
    fill: "#00A76F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3997106,20.2915331 C15.7987736,20.2915331 14.4959141,18.9942401 14.4959141,17.3997206 C14.4959141,15.8052012 15.7981947,14.5079082 17.3997106,14.5079082 C19.0012264,14.5079082 20.304086,15.8052012 20.304086,17.3997206 C20.304086,18.9942402 19.0012265,20.2915331 17.3997106,20.2915331 M17.3997106,13.2 C15.0845449,13.2 13.2,15.0839242 13.2,17.3997206 C13.2,19.7155172 15.0839661,21.6 17.3997106,21.6 C19.7154551,21.6 21.6,19.7155172 21.6,17.3997206 C21.6,15.0839242 19.7154551,13.2 17.3997106,13.2",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1007536,16.7402256 C10.7388172,16.7402256 10.4438625,17.036278 10.4438625,17.4005639 C10.4438625,17.7648496 10.7388172,18.0609022 11.1007536,18.0609022 C11.46269,18.0609022 11.7570571,17.7648496 11.7570571,17.4011278 C11.7570571,17.0362781 11.46269,16.7402256 11.1007536,16.7402256 M8.23170265,16.7402256 C7.86917868,16.7402256 7.57481161,17.036278 7.57481161,17.4005639 C7.57481161,17.7648496 7.86917872,18.0609022 8.23170265,18.0609022 C8.59363903,18.0609022 8.88800615,17.7648496 8.88800615,17.4011278 C8.88800615,17.0362781 8.59363903,16.7402256 8.23170265,16.7402256 M3.01417806,19.080451 C2.07760887,19.080451 1.31554477,18.3270676 1.31554477,17.4005639 C1.31554477,16.474624 2.07760887,15.7212405 3.01417806,15.7212405 C3.95074724,15.7212405 4.71281135,16.474624 4.71281135,17.4005639 C4.71281135,18.3270676 3.95074724,19.081015 3.01476561,19.081015 M3.00712733,14.4005639 C1.34903563,14.4 0,15.7466165 0,17.4 C0,19.0545111 1.35197344,20.4 3.01417806,20.4 C4.67226977,20.4 6.02130539,19.0545111 6.02130539,17.4 C6.02130539,15.7460526 4.6687444,14.4 3.00712733,14.4 M26.9436965,16.7402256 C26.5817601,16.7402256 26.2868054,17.036278 26.2868054,17.4005639 C26.2868054,17.7648496 26.5817601,18.0609022 26.9436965,18.0609022 C27.3056329,18.0609022 27.6,17.7648496 27.6,17.4011278 C27.6,17.0362781 27.3062204,16.7402256 26.9436965,16.7402256 M24.0746456,16.7402256 C23.7127091,16.7402256 23.4177545,17.036278 23.4177545,17.4005639 C23.4177545,17.7648496 23.7127091,18.0609022 24.0746456,18.0609022 C24.436582,18.0609022 24.730949,17.7648496 24.730949,17.4011278 C24.730949,17.0362781 24.436582,16.7402256 24.0746456,16.7402256",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.957226,19.7308028 C32.0111783,19.7308028 31.2424775,18.9545851 31.2424775,18 C31.2424775,17.0459959 32.0111783,16.2697782 32.9566329,16.2697782 C33.9026805,16.2697782 34.6719745,17.0459959 34.6719745,18 C34.6719745,18.9545851 33.9026805,19.7313837 32.957226,19.7313837 M32.957226,14.9090733 C31.2792517,14.9090733 29.9144518,16.2959233 29.9144518,18 C29.9144518,19.7046577 31.2792517,21.0909267 32.957226,21.0909267 C34.6346071,21.0909267 36,19.7046577 36,18 C36,16.2959233 34.6346071,14.9090733 32.957226,14.9090733 M18.2439603,23.9575869 C17.8785902,23.9575869 17.5814303,24.2626126 17.5814303,24.6373585 C17.5814303,25.0126852 17.8785902,25.3177109 18.2439603,25.3177109 C18.6093304,25.3177109 18.9070834,25.0126852 18.9070834,24.6379394 C18.9070834,24.2626126 18.6093304,23.9575869 18.2439603,23.9575869 M18.2439603,26.8910623 C17.8785902,26.8910623 17.5814303,27.1960879 17.5814303,27.5708337 C17.5814303,27.9461605 17.8785902,28.2511863 18.2439603,28.2511863 C18.6093304,28.2511863 18.9070834,27.9461605 18.9070834,27.5714147 C18.9070834,27.1960879 18.6093304,26.8910623 18.2439603,26.8910623 M18.2439603,34.639295 C17.2985058,34.639295 16.529805,33.8630773 16.529805,32.9090733 C16.529805,31.9544883 17.2985058,31.1782706 18.2439603,31.1782706 C19.1894148,31.1782706 19.9587088,31.9544883 19.9587088,32.9090733 C19.9587088,33.8630773 19.1894148,34.639295 18.2445534,34.639295 M18.2445534,29.8251187 C16.565986,29.8251187 15.2017794,31.2113876 15.2017794,32.9160453 C15.2017794,34.6166361 16.565986,36 18.2445534,36 C19.9219345,36 21.2873274,34.61315 21.2873274,32.9090733 C21.2873274,31.2084826 19.9219345,29.8251187 18.2445534,29.8251187 M18.2439603,10.6822891 C17.8785902,10.6822891 17.5814303,10.9873148 17.5814303,11.3626415 C17.5814303,11.7379683 17.8785902,12.0424131 18.2439603,12.0424131 C18.6093304,12.0424131 18.9070834,11.7379683 18.9070834,11.3626415 C18.9070834,10.9873148 18.6093304,10.6828701 18.2439603,10.6828701 M18.2439603,7.74881379 C17.8785902,7.74881379 17.5814303,8.05383945 17.5814303,8.42858526 C17.5814303,8.80391206 17.8785902,9.10893771 18.2439603,9.10893771 C18.6093304,9.10893771 18.9070834,8.80391206 18.9070834,8.42916627 C18.9070834,8.05383945 18.6093304,7.74881379 18.2439603,7.74881379 M18.2439603,4.82231044 C17.2985058,4.82231044 16.529805,4.04551176 16.529805,3.09092668 C16.529805,2.13692262 17.2985058,1.36070494 18.2439603,1.36070494 C19.1894148,1.36070494 19.9587088,2.13692262 19.9587088,3.09150771 C19.9587088,4.04551179 19.1894148,4.82172945 18.2445534,4.82172945 M18.2445534,0 C16.565986,0 15.2017794,1.38685001 15.2017794,3.09092668 C15.2017794,3.91478646 15.5196988,4.68984213 16.0974107,5.27374843 C16.6574368,5.8488506 17.4331792,6.17463133 18.2445534,6.17546237 C19.9219345,6.17546237 21.2873274,4.78861236 21.2873274,3.08453569 C21.2873274,1.38278299 19.9219345,0 18.2445534,0 M14.0855024,22.2110972 C13.9606419,22.0858497 13.7897091,22.0148984 13.6109958,22.0141377 C13.4360214,22.0141377 13.2729097,22.0838578 13.1519106,22.2093541 C12.8862891,22.4806287 12.8855052,22.9085817 13.1501312,23.1807882 C13.2710397,23.3071329 13.4398785,23.3789133 13.6166706,23.3791359 C13.7934626,23.3793533 13.9624872,23.3079936 14.083723,23.1819503 C14.3488007,22.9105965 14.3493231,22.4830717 14.0849093,22.2110972 M11.5706171,24.0836643 C11.2052469,24.0836643 10.9080871,24.3886899 10.9080871,24.7634357 C10.9080871,25.1387625 11.2052469,25.4437881 11.5706171,25.4437881 C11.9359871,25.4437881 12.2337402,25.1387625 12.2337402,24.7640167 C12.2337402,24.3886899 11.9359872,24.0836643 11.5706171,24.0836643 M9.05395232,29.7658565 C8.73782103,30.090676 8.29973497,30.2745868 7.84158776,30.2748136 C7.38390142,30.2748596 6.94626153,30.0908659 6.63100262,29.7658565 C5.96906581,29.0930571 5.96906581,28.0001937 6.63100262,27.3302991 C6.94723517,27.0056939 7.38530814,26.8219985 7.84336718,26.8219232 C8.30185926,26.8219232 8.73128779,27.0020335 9.05395232,27.3308803 C9.72063417,27.9972887 9.72122733,29.0907331 9.05395232,29.7658565 M7.84099462,25.457145 C7.0308894,25.4564152 6.25573798,25.7803284 5.69563132,26.3536361 C4.50402644,27.5592138 4.50402644,29.5200929 5.69563132,30.7250896 C6.25573956,31.3009116 7.03199767,31.6271488 7.84396031,31.6279655 C8.65574541,31.6271259 9.43181089,31.3008795 9.99169614,30.7250896 C11.183301,29.5200929 11.183301,27.5586327 9.99169614,26.3536361 C9.42918566,25.7806067 8.65255927,25.4568825 7.84099462,25.457145 M24.919676,10.5567929 C24.5543058,10.5567929 24.2571461,10.8612375 24.2571461,11.2365643 C24.2571461,11.6118911 24.5543058,11.9163357 24.919676,11.9163357 C25.2850461,11.9163357 25.5827992,11.6118911 25.5827992,11.2365643 C25.5827992,10.8612375 25.2850462,10.5567929 24.919676,10.5567929 M22.8798905,12.6239953 C22.5145204,12.6239953 22.2173605,12.9296021 22.2173605,13.3043479 C22.2173605,13.6796747 22.5145204,13.9847003 22.8798905,13.9847003 C23.2458538,13.9847003 23.5430135,13.6796747 23.5430135,13.3043479 C23.5430135,12.9296021 23.2458538,12.6245763 22.8798905,12.6245763 M29.8592905,8.67028181 C29.5430983,8.99494415 29.1049993,9.17865783 28.646926,9.17865783 C28.1894314,9.17861292 27.7520102,8.99462113 27.436934,8.66970078 C26.7690658,8.00445431 26.7684726,6.91100994 27.436934,6.23414352 C27.7529839,5.90962714 28.1908381,5.72593355 28.6487054,5.72576742 C29.1066044,5.72576742 29.536626,5.90587782 29.8598836,6.23414352 C30.5212274,6.90752401 30.5206342,8.00038735 29.8598836,8.67028181 M30.7946618,5.27432942 C30.2346349,4.69881047 29.4586087,4.37279058 28.646926,4.37203448 C27.835229,4.37272267 27.0591766,4.69875355 26.4991901,5.27432942 C25.3075853,6.47990703 25.3075853,8.44078627 26.4991901,9.64636389 C27.0596545,10.2211529 27.8357768,10.5463248 28.6472226,10.5463248 C29.4586684,10.5463248 30.2347907,10.2211529 30.7952549,9.64636389 C31.9868599,8.44078627 31.9868599,6.47990703 30.7952549,5.27432942 M24.919676,24.0836643 C24.5543058,24.0836643 24.2571461,24.3886899 24.2571461,24.7634357 C24.2571461,25.1387625 24.5543058,25.4437881 24.919676,25.4437881 C25.2850461,25.4437881 25.5827992,25.1387625 25.5827992,24.7640167 C25.5827992,24.3886899 25.2850462,24.0836643 24.919676,24.0836643 M23.344314,22.2105161 C23.223369,22.0841721 23.0543342,22.0126392 22.877518,22.0129699 C22.701336,22.0128671 22.5329007,22.0839075 22.4119083,22.2093541 C22.1486438,22.4819576 22.1483834,22.9084577 22.4113152,23.1813693 C22.5326624,23.3073624 22.7017044,23.3787277 22.8785357,23.3786183 C23.0553671,23.3785077 23.2243164,23.3069323 23.3455002,23.1807882 C23.6079053,22.9083445 23.607645,22.4826518 23.344907,22.2105161 M29.8664081,29.7658565 C29.550419,30.09053 29.1125778,30.274428 28.6546367,30.2748141 C28.1967586,30.2749504 27.7589,30.090955 27.4434584,29.7658565 C26.7815216,29.0930571 26.7815216,28.0007747 27.4434584,27.3302991 C27.7596101,27.0055798 28.1977354,26.8218624 28.6558229,26.821923 C29.1143151,26.821923 29.5443367,27.0020335 29.8670013,27.3308803 C30.53309,27.9972887 30.5336831,29.0907331 29.8670013,29.7658565 M30.7946618,26.3536361 C30.2351622,25.7801643 29.4602913,25.4561892 28.6504847,25.4571406 C27.8384485,25.456853 27.061372,25.7807961 26.498597,26.3542171 C25.3075853,27.5592138 25.3075853,29.520674 26.498597,30.7250896 C27.0586244,31.3010254 27.8349347,31.6272845 28.646926,31.6279655 C29.4586087,31.6272094 30.2346349,31.3011895 30.7946618,30.7256706 C31.9868598,29.5200929 31.9868598,27.5592138 30.7946618,26.3536361 M13.6104026,12.6239953 C13.2450326,12.6239953 12.9472796,12.9296021 12.9472796,13.3043479 C12.9472796,13.6796747 13.2450326,13.9847003 13.6104026,13.9847003 C13.9757728,13.9847003 14.2729325,13.6796747 14.2729325,13.3043479 C14.2729325,12.9296021 13.9763659,12.6245763 13.6104026,12.6245763 M11.5706171,10.5567929 C11.2052469,10.5567929 10.9080871,10.8612375 10.9080871,11.2365643 C10.9080871,11.6118911 11.2052469,11.9163357 11.5706171,11.9163357 C11.9359871,11.9163357 12.2337402,11.6118911 12.2337402,11.2365643 C12.2337402,10.8612375 11.9359872,10.5567929 11.5706171,10.5567929 M9.04683471,8.67028181 C8.73064254,8.99494414 8.29254342,9.17865796 7.83447018,9.17865796 C7.37678383,9.17870382 6.93914391,8.99471019 6.62388501,8.66970078 C5.95601687,8.00445431 5.95542374,6.91100994 6.62388501,6.23414352 C6.94003676,5.90942412 7.37816207,5.72570674 7.83624956,5.72576735 C8.29414852,5.72576735 8.72417017,5.90587782 9.04683471,6.23414352 C9.70877152,6.90752401 9.70877152,8.00038735 9.04683471,8.67028181 M7.84099462,4.37203448 C7.02932626,4.37285845 6.25332605,4.69886738 5.69325881,5.27432942 C4.50224706,6.47990703 4.50224706,8.44078627 5.69325881,9.64636389 C6.2527993,10.2201958 7.02792828,10.5443993 7.83802895,10.5434407 C8.65015286,10.5435761 9.4272424,10.219418 9.9899167,9.64578287 C11.1809285,8.44078627 11.1809285,6.47932604 9.9899167,5.27432942 C9.42956502,4.69857562 8.65307513,4.37254106 7.84099462,4.37203448",
    id: "\\u5F62\\u72B6"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u8DEF\\u5F84",
    stroke: "#979797",
    mask: "url(#mask-4)",
    strokeWidth: 2,
    fill: "#FBFBFB",
    fillRule: "nonzero",
    strokeDasharray: 10,
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.088235,163 L538.911765,163 C540.61735,163 542,164.014212 542,165.265306 L542,271.734694 C542,272.985788 540.61735,274 538.911765,274 L370.088235,274 C368.38265,274 367,272.985788 367,271.734694 L367,165.265306 C367,164.014212 368.38265,163 370.088235,163 Z",
    id: "path-1",
    fill: "#FBFBFB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("use", {
    id: "path-1",
    stroke: "#979797",
    mask: "url(#mask-6)",
    strokeWidth: 2,
    fill: "#FBFBFB",
    fillRule: "nonzero",
    strokeDasharray: 10,
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Dragonfly-1.0-was-op",
    transform: "translate(33, -27)",
    fill: "#959595",
    fillRule: "nonzero",
    fontFamily: "Helvetica",
    fontSize: 12,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Dragonfly-1.0-was-open-"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 159,
    y: 201
  }, "Dragonfly 1.0 was open-")), /*#__PURE__*/React.createElement("text", {
    id: "sourced-in-November-2017."
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 159,
    y: 215
  }, "sourced in November 2017."))), /*#__PURE__*/React.createElement("g", {
    id: "Joined-the-CNCF-as-a",
    transform: "translate(51, -11)",
    fill: "#6C6C6C",
    fillRule: "nonzero",
    fontFamily: "Helvetica",
    fontSize: 12,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("text", null, /*#__PURE__*/React.createElement("tspan", {
    x: 336,
    y: 242
  }, "Joined the CNCF as a")), /*#__PURE__*/React.createElement("text", {
    id: "Sandbox-project-in"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 336,
    y: 256
  }, "Sandbox project in")), /*#__PURE__*/React.createElement("text", {
    id: "October-2018."
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 336,
    y: 270
  }, "October 2018."))), /*#__PURE__*/React.createElement("g", {
    id: "The-CNCF-TOC-voted-f",
    transform: "translate(39, -13)",
    fill: "#6C6C6C",
    fillRule: "nonzero",
    fontFamily: "Helvetica",
    fontSize: 12,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("text", {
    id: "The-CNCF-TOC-voted-for"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 147,
    y: 478
  }, "The CNCF TOC voted for")), /*#__PURE__*/React.createElement("text", {
    id: "Dragonfly-to-became-a-Graduated"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 147,
    y: 492
  }, "Dragonfly to became a Graduated")), /*#__PURE__*/React.createElement("text", {
    id: "Project-in-November-2025."
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 147,
    y: 506
  }, "Project in November 2025."))), /*#__PURE__*/React.createElement("g", {
    id: "CNCF-TOC-voted-for-D",
    transform: "translate(38, -28)",
    fill: "#6C6C6C",
    fillRule: "nonzero",
    fontFamily: "Helvetica",
    fontSize: 12,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("text", {
    id: "CNCF-TOC-voted-for"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 123.573242,
    y: 330
  }, "CNCF TOC voted for")), /*#__PURE__*/React.createElement("text", {
    id: "Dragonfly-to-became-an"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 123.573242,
    y: 344
  }, "Dragonfly to became an")), /*#__PURE__*/React.createElement("text", {
    id: "Incubating-Project-in-April"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 123.573242,
    y: 358
  }, "Incubating Project in April")), /*#__PURE__*/React.createElement("text", {
    id: 2020
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 123.573242,
    y: 372
  }, "2020."))), /*#__PURE__*/React.createElement("g", {
    id: "Dragonfly-2.0-was-re",
    transform: "translate(38, -18)",
    fill: "#6C6C6C",
    fillRule: "nonzero",
    fontFamily: "Helvetica",
    fontSize: 12,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Dragonfly-2.0-was-released"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 336,
    y: 391
  }, "Dragonfly 2.0 was released")), /*#__PURE__*/React.createElement("text", {
    id: "in-April-2021."
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 336,
    y: 405
  }, "in April 2021."))), /*#__PURE__*/React.createElement("g", {
    id: "Dragonfly",
    transform: "translate(33, -27)",
    fill: "#353434",
    fillRule: "nonzero",
    fontFamily: "Helvetica",
    fontSize: 24,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("text", null, /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 86
  }, "Dragonfly"))), /*#__PURE__*/React.createElement("g", {
    id: "Dragonfly-1.0",
    transform: "translate(33, -27)",
    fill: "#353434",
    fillRule: "nonzero",
    fontFamily: "Helvetica",
    fontSize: 14,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("text", null, /*#__PURE__*/React.createElement("tspan", {
    x: 203,
    y: 166
  }, "Dragonfly 1.0"))), /*#__PURE__*/React.createElement("g", {
    id: "CNCF-SandBox",
    transform: "translate(39, -13)",
    fill: "#353434",
    fillRule: "nonzero",
    fontFamily: "Helvetica",
    fontSize: 14,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("text", null, /*#__PURE__*/React.createElement("tspan", {
    x: 385,
    y: 201
  }, "CNCF SandBox"))), /*#__PURE__*/React.createElement("g", {
    id: "Dragonfly-2.0",
    transform: "translate(43, -17)",
    fill: "#353434",
    fillRule: "nonzero",
    fontFamily: "Helvetica",
    fontSize: 14,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("text", null, /*#__PURE__*/React.createElement("tspan", {
    x: 385,
    y: 350
  }, "Dragonfly 2.0"))), /*#__PURE__*/React.createElement("g", {
    id: "CNCF-Incubating",
    transform: "translate(39, -26)",
    fill: "#353434",
    fillRule: "nonzero",
    fontFamily: "Helvetica",
    fontSize: 14,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("text", null, /*#__PURE__*/React.createElement("tspan", {
    x: 168,
    y: 289
  }, "CNCF Incubating"))), /*#__PURE__*/React.createElement("g", {
    id: "Dragonfly-Graduated",
    transform: "translate(228, 406)",
    fill: "#353434",
    fillRule: "nonzero",
    fontFamily: "Helvetica",
    fontSize: 14,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("text", null, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9
  }, "Dragonfly Graduated"))), /*#__PURE__*/React.createElement("g", {
    id: "\\u63A5\\u5165\\u6C99\\u7BB1\\u73AF\\u5883_icon-(1)",
    transform: "translate(377, 168)",
    fill: "#00A76F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6460475,11.4071216 C23.0778656,11.4071216 23.5096838,11.7590122 23.5096838,12.2868482 L23.5096838,14.4861647 L27.2233202,14.4861647 C27.6551384,14.4861647 28.0005929,14.8380553 28.0869565,15.2779186 C28.0869565,15.717782 27.9142292,16.0696727 27.4824111,16.1576452 L23.5096838,16.1576452 L23.5096838,18.3569617 C23.5096838,18.796825 23.1642292,19.2366883 22.6460475,19.2366883 L15.8233202,19.2366883 C15.3915019,19.2366883 14.9596838,18.8847977 14.9596838,18.3569617 L14.9596838,16.1576452 L10.7278656,16.1576452 L10.7278656,23.5473487 L13.3187748,23.5473487 L13.3187748,21.3480322 C13.3187748,20.9081689 13.6642292,20.4683057 14.1824111,20.4683056 L24.3733202,20.4683056 C24.8051384,20.4683056 25.2369565,20.8201962 25.2369565,21.3480322 L25.2369565,27.4181458 C25.2369565,27.8580091 24.8915019,28.2978723 24.3733202,28.2978723 L14.1824111,28.2978723 C13.7505929,28.2978723 13.3187748,27.9459817 13.3187748,27.4181458 L13.3187748,25.2188293 L10.2096838,25.2188293 C9.6051384,25.1308565 9.17332017,24.6909933 9.08695652,24.0751846 L9.08695652,15.5418366 C9.17332017,14.926028 9.6051383,14.4861647 10.2096838,14.398192 L14.9596838,14.398192 L14.9596838,12.1988755 C14.9596838,11.7590122 15.3051384,11.3191489 15.8233202,11.3191489 L22.6460475,11.3191489 L22.6460475,11.4071216 Z M23.5096838,22.2277588 L15.0460475,22.2277588 L15.0460475,26.6263918 L23.5096838,26.6263918 L23.5096838,22.2277588 L23.5096838,22.2277588 Z M21.7824111,13.1665748 L16.6869565,13.1665748 L16.6869565,17.5652078 L21.7824111,17.5652078 L21.7824111,13.1665748 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,0 C29.5363636,0 38,8.46363636 38,19 C38,29.5363636 29.5363636,38 19,38 C8.46363636,38 0,29.5363636 0,19 C0,8.46363636 8.46363636,0 19,0 Z M19,1.72727275 C9.5,1.72727275 1.72727275,9.5 1.72727275,19 C1.72727275,28.5 9.5,36.2727273 19,36.2727273 C28.5,36.2727273 36.2727273,28.5 36.2727273,19 C36.2727273,9.5 28.5,1.72727275 19,1.72727275 Z",
    id: "\\u5F62\\u72B6"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 428.00005,
    y1: 347.00005,
    x2: 507.5,
    y2: 347.5,
    id: "\\u8DEF\\u5F84-5",
    stroke: "#797979"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.5,
    y1: 280.329215,
    x2: 309,
    y2: 280.329215,
    id: "\\u8DEF\\u5F84-6",
    stroke: "#797979"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 428.5,
    y1: 205.5,
    x2: 520,
    y2: 205.329215,
    id: "\\u8DEF\\u5F84-6",
    stroke: "#797979"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.5,
    y1: 149.329215,
    x2: 321.499995,
    y2: 149.505958,
    id: "\\u8DEF\\u5F84-6",
    stroke: "#797979"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.5,
    y1: 434.5,
    x2: 355.5,
    y2: 434.5,
    id: "\\u8DEF\\u5F84-6",
    stroke: "#797979"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7248\\u672C\\u66F4\\u65B0-(1)",
    transform: "translate(377, 319)",
    fill: "#00A76F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0768739,11.8406842 C30.7151947,15.3375698 28.7228251,18.4145571 25.9314677,20.9560467 C25.7217853,21.1311471 25.6197448,21.4036887 25.6628718,21.6734438 C25.7597703,22.6152399 25.837969,23.557036 25.9348676,24.497132 C26.1626641,26.6901231 25.3891758,28.4853158 23.609303,29.7603105 C21.7002322,31.1254049 19.7146625,32.3867997 17.7443925,33.6668943 C16.5034114,34.472691 14.9768347,33.7416941 14.8374368,32.2780002 C14.6793391,30.5984071 14.5535411,28.913714 14.4362429,27.2307209 C14.3784438,26.3875244 14.4022435,26.3807244 13.5794559,26.2736248 C11.4000892,25.988026 9.6933152,24.9595303 8.52203309,23.0946379 C7.9185423,22.1324418 7.62104681,21.0716462 7.51564844,19.9547509 C7.48334892,19.6215522 7.34735099,19.5348526 7.02945582,19.5178526 C5.26608036,19.4244539 3.50368537,19.3133822 1.74253643,19.184654 C0.275458783,19.0741544 -0.467429886,17.5407608 0.317958166,16.258966 C0.870449751,15.3579697 1.45694081,14.4790733 2.0264321,13.5899771 C2.64012276,12.631181 3.25041342,11.670685 3.86410409,10.7135889 C4.9911869,8.96259608 6.61296217,8.01739998 8.69203049,8.00040006 C9.88031237,7.99020011 11.0719942,8.19929923 12.2619761,8.3267987 C12.4863726,8.3505986 12.6444702,8.31999874 12.8008679,8.14659946 C15.5616258,5.08151206 18.9768737,3.01262058 22.8443147,1.62882629 C25.0304815,0.846829515 27.2795471,0.336831603 29.5881119,0.0988325863 C30.7508941,-0.0201669388 31.9221764,-0.0626667619 33.0832587,0.149832354 C33.717349,0.268831879 33.7496485,0.29263177 33.848247,0.908029236 C33.9451456,1.52002671 34.0216443,2.13882417 33.9944447,2.76442158 C33.8958462,5.90260867 33.2141566,8.91839624 32.0768739,11.8406842 Z M23.5855034,6.61830572 C21.455436,6.58430589 19.612664,8.12109956 19.5616648,10.5214897 C19.5191654,12.5240815 21.3466375,14.337974 23.3832065,14.3532739 C24.4182211,14.3668822 25.4161485,13.968263 26.1569525,13.2453097 C26.8977562,12.5223561 27.3205989,11.5344398 27.3322463,10.4993897 C27.3594459,8.43219826 25.6339722,6.65230558 23.5855034,6.61830572 Z M4.44379525,22.3075412 C4.96568728,22.3160412 5.25468288,22.5455401 5.44168006,23.072538 C6.12983988,25.0970882 7.56147646,26.7845665 9.44681898,27.7934186 C9.87521247,28.0297176 10.3240056,28.2201168 10.7897985,28.3782161 C11.6261858,28.6621149 11.8165828,29.4713117 11.1977923,30.0952091 C10.2781063,31.0166053 9.3482205,31.9278016 8.4302345,32.8491977 C8.12593915,33.1551965 7.7927442,33.297996 7.36435072,33.1398965 C6.93085733,32.9800972 6.72176054,32.6604985 6.69966086,32.2134004 C6.68606107,31.9312015 6.69286097,31.6473027 6.68606107,31.3634039 C6.67416125,30.841506 6.66906134,30.836406 6.18626868,30.9962053 L3.09061587,32.0196011 C2.78462054,32.1199009 2.47862521,32.1607006 2.18282971,31.9941012 C1.74593638,31.7476023 1.58103888,31.3090042 1.7578362,30.7684063 C2.099531,29.7144107 2.45992551,28.6672149 2.81012015,27.6149193 C2.96311783,27.1593211 2.95291798,27.1491211 2.45652557,27.1423213 C2.15733012,27.1372213 1.85813468,27.1423213 1.55893924,27.1287213 C1.15181126,27.1309669 0.788319485,26.8740601 0.65455302,26.489524 C0.496455416,26.0900256 0.596753895,25.741527 0.890849432,25.4491282 C1.84963483,24.490332 2.81182014,23.536636 3.77570545,22.58294 C3.9449172,22.3942937 4.19080134,22.2929358 4.44379525,22.3075412",
    id: "\\u5F62\\u72B6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211.056527,419.212197 L210.263699,419.212197 C212.185836,417.688467 213.401863,415.449492 213.401863,412.957314 L213.401863,402.050781 L215.5,402.050781 L215.5,407.929688 L217.760274,407.929688 L217.760274,402.050781 L219.756849,402.050781 L219.756849,400 L189.243151,400 L189.243151,402.050781 L195.093644,402.050781 L195.093644,412.957314 C195.093644,415.449492 196.310048,417.688467 198.231884,419.212197 L197.943473,419.212197 C192.4605,419.212197 188,423.259551 188,428.233994 L188,435 L221,435 L221,428.233994 C221,423.259482 216.5395,419.212197 211.056527,419.212197 Z M210.578947,401.590909 L210.578947,408.75 L196.684211,408.75 L196.684211,401.590909 L210.578947,401.590909 Z M196.684211,413.127297 L196.684211,411.136364 L210.578947,411.136364 L210.578947,413.127297 C210.578947,416.415626 207.462274,419.090909 203.631579,419.090909 C199.800884,419.090909 196.684211,416.415626 196.684211,413.127297 L196.684211,413.127297 Z M208.842105,421.477273 L204.065789,427.045455 L199.289474,421.477273 L208.842105,421.477273 Z M218.394737,433.409091 L189.736842,433.409091 L189.736842,428.57112 C189.736842,424.937926 192.680569,421.928476 196.477209,421.477273 L204.065789,430.970151 L211.65437,421.477273 C215.45101,421.928476 218.394737,424.937926 218.394737,428.57112 L218.394737,433.409091 Z",
    id: "\\u5F62\\u72B6",
    fill: "#00A76F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6",
    transform: "translate(192, 125)",
    fill: "#00A76F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1706696,16.4926503 L15.8667356,22.4002552 C14.6894626,22.9488557 14.2207622,22.9488557 13.1332644,22.4002552 L0.829358729,16.4926503 C0.176860007,16.1222846 0,14.7507835 0,14.0026508 C0.822278667,14.5033695 1.97576274,15.0625432 1.93370716,15.0339954 L14.5,21.2219425 L27.0662928,15.0339954 C27.0886658,15.0281046 28.2085904,14.4254296 29,14.0026508 C29,14.768607 28.7768647,16.1896513 28.1706696,16.4926503 L28.1706696,16.4926503 Z M28.1706696,10.303072 L15.8667356,16.2123082 C14.6894626,16.7593982 14.2207622,16.7593982 13.1332644,16.2123082 L0.829358729,10.303072 C-0.136163797,9.75598199 -0.106625768,8.03057925 0.829358729,7.38597375 L13.1332644,0.446963727 C14.2207622,-0.133144978 14.899882,-0.164623043 15.8667356,0.446963727 L28.1706413,7.38597375 C29.1066541,7.93466481 29.075785,9.8534069 28.1706696,10.303072 L28.1706696,10.303072 Z M14.5,1.62527649 C14.5933373,1.66585182 14.6263861,1.82842618 14.5,1.62527649 L14.5,1.62527649 Z M14.5,27.4115208 L27.0662928,21.2219123 C27.0886658,21.2173809 28.2085904,20.6133464 29,20.1905676 C29,20.9566748 28.7768364,22.3792296 28.1706413,22.6804161 L15.8667356,28.5896825 C14.6894626,29.1367725 14.2207622,29.1367725 13.1332644,28.5896825 L0.829358729,22.6804463 C0.176860007,22.3103826 0,20.9400899 0,20.1905676 C0.822278667,20.692827 1.97576274,21.2504902 1.93370716,21.2219425 L14.5,27.4115208 L14.5,27.4115208 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragonflyLight);
export default __webpack_public_path__ + "static/media/dragonflyLight.2206e9b3950c6c1e3e53326d49998ac6.svg";
export { ForwardRef as ReactComponent };